import {useEffect, useState} from "react";
import {getArticlesByTag} from "../api/tag/requests";
import {STATUS_NOT_FOUND} from "../constants/httpStatusCodes";
import {useShowErrorFlashMessage} from "../features/flashMessage/store";

function useTagArticles(tag, perPage, page = 1) {
  const [currentArticles, setCurrentArticles] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const showErrorFlashMessage = useShowErrorFlashMessage();

  useEffect(() => {
    setCurrentArticles([]);

    getArticlesByTag({tag, page, pageSize: perPage})
      .then(({total, articles}) => {
        if (articles?.length > 0) {
          setCurrentArticles(articles);
          setTotal(total);
        }
      })
      .catch(err => {
        if (err.status !== STATUS_NOT_FOUND) {
          console.error(err);
          showErrorFlashMessage("api.network_error");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [page, tag, perPage]);

  return [currentArticles, total, isLoading];
}

export {useTagArticles};
